import * as React from 'react';
import * as moment from "moment";
import { safe } from "../../utils";
import { IPageProperties } from "../../models";
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { AnalystRating, MorningstarRating, Disclaimer } from "../../assets";

const styles = require('./styles.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');

export class PageRatings extends React.Component<IPageProperties, {}>{
    constructor(props) {
        super(props);
        this.getDisclclaimers = this.getDisclclaimers.bind(this);
    }

    getDisclclaimers(disclaimerType) {
        let { appParams, shareClass, disclaimers } = this.props;
        return (
            <div className={ styles.disclaimer }>
                <Disclaimer date={ safe(() => shareClass.statisticsMapping.morning_star_rating.date, "") } appParams={ appParams } disclaimer={ disclaimers[disclaimerType] } />
            </div>
        );
    }

    render() {
        let { isLoading, shareClass, fund, appParams, disclaimers } = this.props;
        if (!shareClass || Object.keys(disclaimers).length === 0) {
            return null;
        } else if (!shareClass.properties.analyst_rating && !shareClass.properties.morningstar_rating) {
            return null;
        } else {
            let disclaymerType: string;
            let hideAnalystRating = appParams.clienttype === "pri" || appParams.clienttype === "cha" || appParams.clienttype === "dtc";
            if ((!shareClass.properties.analyst_rating && shareClass.properties.morningstar_rating) || hideAnalystRating) {
                disclaymerType= "ratings_ratingsmorningstaroverall";
            }
            else if (shareClass.properties.analyst_rating && !shareClass.properties.morningstar_rating) {
                disclaymerType= "ratings_ratingsmorningstaranalyst";
            }
            else if (shareClass.properties.analyst_rating && shareClass.properties.morningstar_rating) {
                disclaymerType= "ratings_ratingsmorningstaroverallandanalyst";
            }

            let ratingDate = safe(() => shareClass.statisticsMapping["morning_star_rating"].date, "");
            return (
                <div className={ styles.wrapper }>
                    <div className={ styles.ratingsContainer }>
                        <BackToTop styles={ backToTopstyles } />
                        <div className={ styles.row }>
                            <h2 className={ styles.title + ' ' + styles.reasons }>Ratings</h2>
                            { /*
                            <div className={styles.colXs12 + ' ' + styles.noPadding}>
                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-01.jpg') } />
                                </div>
                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-02.jpg') } />
                                </div>
                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-03.jpg') } />
                                </div>
                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-04.jpg') } />
                                </div>

                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-05.jpg') } />
                                </div>
                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-06.jpg') } />
                                </div>
                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-07.jpg') } />
                                </div>
                                <div className={styles.colMd3 + ' ' + styles.imageBox}>
                                    <img style={{ width: 'auto', height: 'auto'}} src={ require('../../images/ratings-08.jpg') } />
                                </div>
                            </div>
                        */ }
                        </div>
                        <div className={ styles.row + ' ' + styles.colXs12 }>
                            <div className={ styles.colMd6 }>
                                <h4 className={ styles.morningStarTitle }>Morningstar</h4>
                                <div className={ styles.introduction }>
                                    { /*Ratings should not be taken as a recommendation.*/ }
                                </div>
                                <table>
                                    <tbody>
                                        { (() => {
                                            if (shareClass.properties.morningstar_rating) {
                                                return (
                                                    <tr>
                                                        <td className={ styles.first }>Overall Morningstar rating</td>
                                                        <td className={ styles.right }><MorningstarRating stars={ shareClass.properties.morningstar_rating } /></td>
                                                    </tr>
                                                );
                                            }
                                        })() }
                                        { (() => {
                                            if (shareClass.properties.analyst_rating && !hideAnalystRating) {
                                                return (
                                                    <tr>
                                                        <td className={ styles.first}>Morningstar Analyst rating</td>
                                                        <td className={ styles.right }><AnalystRating stars={ shareClass.properties.analyst_rating } /></td>
                                                    </tr>
                                                );
                                            }
                                        })() }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        { this.getDisclclaimers(disclaymerType) }
                    </div>
                </div >
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PageRatings/index.tsx